<template>
  <div class="sidebar">
    <div class="sidebar" :class="{'sidebar-active':isActive}">
      <a
        v-if="!isActive"
        class="button toggle-sidebar-btn is-semibold-16-600-19"
        style="border:none;writing-mode: vertical-rl;text-orientation: mixed;height:100vh;width:40px"
        @click="toggle_sidebar()"
      >
        <template v-if="orthos && orthos.length">{{orthos[0][0].viewName}}</template>
        <img
          class="toggle-sidebar-btn is-semibold-16-600-19"
          style="border:none;right:-22px"
          @click.stop="toggle_sidebar()"
          src="@/assets/expand-collapse.svg"
        />
      </a>
      <a
        v-else
        class="toggle-sidebar-btn is-semibold-16-600-19"
        style="border:none;top:45vh;right:-22px"
        @click="toggle_sidebar()"
      >
        <img src="@/assets/expand.svg" />
      </a>
      <div class="card sidebar__card" style="background-color: #f4f7fc;">
        <div class="card-header has-text-centered">
          <!-- style="box-shadow:none" -->
          <h2
            class="card-header-title is-semiBold-16-600-19 viewer-name"
            v-if="orthos && orthos.length"
          >{{orthos[0][0].viewName}}</h2>
        </div>
        <div class="card-content" style="padding:0">
          <div class="content">
            <export-import></export-import>
              <nav-menu class="nav-menu"></nav-menu>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ExportImportComponent from "./components/export-import/export-import.component";
import NavMenuComponent from "./components/menu/nav-menu.component";
import { mapState } from "vuex";
export default {
  data() {
    return {
      isActive: true
    };
  },
  computed: {
    ...mapState(["orthos"])
  },
  methods: {
    toggle_sidebar() {
      this.isActive = !this.isActive;
      parent.postMessage({ name: "sidebar_toggle", open: this.isActive }, "*");
    }
  },
  components: {
    "export-import": ExportImportComponent,
    "nav-menu": NavMenuComponent
  }
};
</script>
<style lang="scss" scoped>
.sidebar {
  background-color: #f4f7fc;
  height: 0;
  &__card .card-content {
    padding: 0 1rem;
  }
  &__card .card-header-title.viewer-name {
    justify-content: center;
  }
}
.toggle-sidebar-btn {
  position: absolute;
  // top: 200px;
  z-index: 1;
  right: -40px;
  height: auto;
  transition: all 0.5s;
  border: none;
  border-radius: 0;
  padding: 3px;
}
.sidebar {
  position: fixed;
  left: -22rem;
  width: 22rem;
  top: 0px;
  z-index: 999;
  transition: all 0.5s;
  &__card {
    background-color: #f4f7fc;
    height: 100vh;
  }
  // @media (max-width: 1400px) {
  //   width: 25%;
  //   left: -25%;
  // }
  // @media (max-width: 1200px) {
  //   width: 25%;
  //   left: -25%;
  // }
  // @media (max-width: 1100px) {
  //   width: 30%;
  //   left: -30%;
  // }
  // @media (max-width: 768px) {
  //   width: 45%;
  //   left: -45%;
  // }
  // @media (max-width: 600px) {
  //   width: 50%;
  //   left: -50%;
  // }
  // @media (max-width: 450px) {
  //   width: 80%;
  //   left: -80%;
  // }

  .nav-menu {
    height: 69vh;
  }
  &-active {
    left: 0%;
  }
}
</style>
